import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { Layout } from './components/layout/Layout';
const Home = lazy(() => import('./pages/Home').then(m => ({
  default: m.Home
})));
const About = lazy(() => import('./pages/About').then(m => ({
  default: m.About
})));
const Services = lazy(() => import('./pages/Services').then(m => ({
  default: m.Services
})));
const Workshops = lazy(() => import('./pages/Workshops').then(m => ({
  default: m.Workshops
})));
const Talks = lazy(() => import('./pages/Talks').then(m => ({
  default: m.Talks
})));
const Courses = lazy(() => import('./pages/Courses').then(m => ({
  default: m.Courses
})));
const Events = lazy(() => import('./pages/Events').then(m => ({
  default: m.Events
})));
const Contact = lazy(() => import('./pages/Contact').then(m => ({
  default: m.Contact
})));
const Privacy = lazy(() => import('./pages/Privacy').then(m => ({
  default: m.Privacy
})));
const Terms = lazy(() => import('./pages/Terms').then(m => ({
  default: m.Terms
})));
const Writing = lazy(() => import('./pages/Writing').then(m => ({
  default: m.Writing
})));

// Challenge landing pages
const NewToLeadership = lazy(() => import('./pages/services/NewToLeadership').then(m => ({
  default: m.NewToLeadership
})));
const ConflictAndConversations = lazy(() => import('./pages/services/ConflictAndConversations').then(m => ({
  default: m.ConflictAndConversations
})));
const MeetingsAndFacilitation = lazy(() => import('./pages/services/MeetingsAndFacilitation').then(m => ({
  default: m.MeetingsAndFacilitation
})));
const LeadingInComplexity = lazy(() => import('./pages/services/LeadingInComplexity').then(m => ({
  default: m.LeadingInComplexity
})));

// How I work
const Coaching = lazy(() => import('./pages/services/Coaching').then(m => ({
  default: m.Coaching
})));
const EmbeddedPartner = lazy(() => import('./pages/services/EmbeddedPartner').then(m => ({
  default: m.EmbeddedPartner
})));

// Course detail pages
const ConflictCoaching = lazy(() => import('./pages/courses/ConflictCoaching').then(m => ({
  default: m.ConflictCoaching
})));
const FirstTimeManager = lazy(() => import('./pages/courses/FirstTimeManager').then(m => ({
  default: m.FirstTimeManager
})));
const BetterOnlineMeetings = lazy(() => import('./pages/courses/BetterOnlineMeetings').then(m => ({
  default: m.BetterOnlineMeetings
})));
const BetterOnlineWorkshops = lazy(() => import('./pages/courses/BetterOnlineWorkshops').then(m => ({
  default: m.BetterOnlineWorkshops
})));
const ModernProductManagement = lazy(() => import('./pages/courses/ModernProductManagement').then(m => ({
  default: m.ModernProductManagement
})));
const ArtOfFacilitation = lazy(() => import('./pages/courses/ArtOfFacilitation').then(m => ({
  default: m.ArtOfFacilitation
})));

// Workshop detail pages
const StrategyWorkshop = lazy(() => import('./pages/workshops/StrategyWorkshop').then(m => ({
  default: m.StrategyWorkshop
})));
const FeedbackWorkshop = lazy(() => import('./pages/workshops/FeedbackWorkshop').then(m => ({
  default: m.FeedbackWorkshop
})));
const CoachingSkillsForManagers = lazy(() => import('./pages/workshops/CoachingSkillsForManagers').then(m => ({
  default: m.CoachingSkillsForManagers
})));

// Writing series pages
const OnFeedback = lazy(() => import('./pages/writing/OnFeedback').then(m => ({
  default: m.OnFeedback
})));
const OnConflict = lazy(() => import('./pages/writing/OnConflict').then(m => ({
  default: m.OnConflict
})));
const LessonsOfLeadership = lazy(() => import('./pages/writing/LessonsOfLeadership').then(m => ({
  default: m.LessonsOfLeadership
})));
const LessonsOfAgility = lazy(() => import('./pages/writing/LessonsOfAgility').then(m => ({
  default: m.LessonsOfAgility
})));
const LessonsOfStrategy = lazy(() => import('./pages/writing/LessonsOfStrategy').then(m => ({
  default: m.LessonsOfStrategy
})));
const OnTeams = lazy(() => import('./pages/writing/OnTeams').then(m => ({
  default: m.OnTeams
})));
function LoadingFallback() {
  return <div className="min-h-[60vh] flex items-center justify-center" data-id="element-0">
      <div className="w-8 h-8 border-3 border-teal border-t-transparent rounded-full animate-spin" data-id="element-1" />
    </div>;
}
function AnimatedRoutes() {
  return <Suspense fallback={<LoadingFallback data-id="element-3" />} data-id="element-2">
      <Routes data-id="element-4">
        <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
        <Route path="/about" element={<About data-id="element-8" />} data-id="element-7" />
        <Route path="/events" element={<Events data-id="element-10" />} data-id="element-9" />

        {/* Writing */}
        <Route path="/writing" element={<Writing data-id="element-12" />} data-id="element-11" />
        <Route path="/writing/on-feedback" element={<OnFeedback data-id="element-14" />} data-id="element-13" />
        <Route path="/writing/on-conflict" element={<OnConflict data-id="element-16" />} data-id="element-15" />
        <Route path="/writing/lessons-of-leadership" element={<LessonsOfLeadership data-id="element-18" />} data-id="element-17" />
        <Route path="/writing/lessons-of-agility" element={<LessonsOfAgility data-id="element-20" />} data-id="element-19" />
        <Route path="/writing/lessons-of-strategy" element={<LessonsOfStrategy data-id="element-22" />} data-id="element-21" />
        <Route path="/writing/on-teams" element={<OnTeams data-id="element-24" />} data-id="element-23" />

        {/* Services overview */}
        <Route path="/services" element={<Services data-id="element-26" />} data-id="element-25" />

        {/* Challenge landing pages */}
        <Route path="/services/new-to-leadership" element={<NewToLeadership data-id="element-28" />} data-id="element-27" />
        <Route path="/services/conflict-and-conversations" element={<ConflictAndConversations data-id="element-30" />} data-id="element-29" />
        <Route path="/services/meetings-and-facilitation" element={<MeetingsAndFacilitation data-id="element-32" />} data-id="element-31" />
        <Route path="/services/leading-in-complexity" element={<LeadingInComplexity data-id="element-34" />} data-id="element-33" />

        {/* How I work */}
        <Route path="/services/coaching" element={<Coaching data-id="element-36" />} data-id="element-35" />
        <Route path="/services/embedded-partner" element={<EmbeddedPartner data-id="element-38" />} data-id="element-37" />

        {/* Format index pages */}
        <Route path="/services/courses" element={<Courses data-id="element-40" />} data-id="element-39" />
        <Route path="/services/workshops" element={<Workshops data-id="element-42" />} data-id="element-41" />
        <Route path="/services/talks" element={<Talks data-id="element-44" />} data-id="element-43" />

        {/* Course detail pages */}
        <Route path="/services/courses/conflict-coaching" element={<ConflictCoaching data-id="element-46" />} data-id="element-45" />
        <Route path="/services/courses/first-time-manager" element={<FirstTimeManager data-id="element-48" />} data-id="element-47" />
        <Route path="/services/courses/better-online-meetings" element={<BetterOnlineMeetings data-id="element-50" />} data-id="element-49" />
        <Route path="/services/courses/better-online-workshops" element={<BetterOnlineWorkshops data-id="element-52" />} data-id="element-51" />
        <Route path="/services/courses/modern-product-management" element={<ModernProductManagement data-id="element-54" />} data-id="element-53" />
        <Route path="/services/courses/art-of-facilitation" element={<ArtOfFacilitation data-id="element-56" />} data-id="element-55" />

        {/* Workshop detail pages */}
        <Route path="/services/workshops/strategy" element={<StrategyWorkshop data-id="element-58" />} data-id="element-57" />
        <Route path="/services/workshops/feedback-culture" element={<FeedbackWorkshop data-id="element-60" />} data-id="element-59" />
        <Route path="/services/workshops/coaching-skills" element={<CoachingSkillsForManagers data-id="element-62" />} data-id="element-61" />

        {/* Legal */}
        <Route path="/privacy" element={<Privacy data-id="element-64" />} data-id="element-63" />
        <Route path="/terms" element={<Terms data-id="element-66" />} data-id="element-65" />
        <Route path="/contact" element={<Contact data-id="element-68" />} data-id="element-67" />
      </Routes>
    </Suspense>;
}
export function App() {
  return <Router data-id="element-69">
      <LanguageProvider data-id="element-70">
        <Layout data-id="element-71">
          <AnimatedRoutes data-id="element-72" />
        </Layout>
      </LanguageProvider>
    </Router>;
}